import React, { useState, useEffect } from 'react';
import axios from 'axios';

function EducationalVideoDialog({ isOpen, onClose, user }) {
    const [categories, setCategories] = useState([]);
    const [videos, setVideos] = useState([]);
    const [filteredVideos, setFilteredVideos] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedVideo, setSelectedVideo] = useState('');
    const [videoPreviewId, setVideoPreviewId] = useState('');
    const [smsContent, setSmsContent] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [history, setHistory] = useState([]);
    const [isHistoryLoading, setIsHistoryLoading] = useState(false);
    //const eduUrl = "https://ginsengs-edu-front.web.app/watch/"
    const eduUrl = "https://www.youtube.com/watch?v="
    
    useEffect(() => {
        if (isOpen) {
            fetchCategoriesAndVideos();
            fetchHistory();
        } else {
            // 초기화
            setSelectedCategory('');
            setSelectedVideo('');
            setVideoPreviewId('');
            setSmsContent('');
            setHistory([]);
        }
    }, [isOpen]);

    const fetchHistory = async () => {
        if (!user || !user.name) return;
        setIsHistoryLoading(true);
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get('/api/messages/educational-video-history', {
                headers: { Authorization: `Bearer ${token}` },
                params: { recipientName: user.name }
            });
            if (res.data.success) {
                setHistory(res.data.history);
            }
        } catch (error) {
            console.error('발송 이력 조회 실패', error);
        } finally {
            setIsHistoryLoading(false);
        }
    };

    const fetchCategoriesAndVideos = async () => {
        try {
            const token = localStorage.getItem('token');
            const [catRes, vidRes] = await Promise.all([
                axios.get('/api/video-categories', { headers: { Authorization: `Bearer ${token}` } }),
                axios.get('/api/videos', { headers: { Authorization: `Bearer ${token}` } })
            ]);

            if (catRes.data.success) {
                setCategories(catRes.data.categories);
            }
            if (vidRes.data.success) {
                setVideos(vidRes.data.videos);
            }
        } catch (error) {
            console.error('Failed to fetch video data', error);
        }
    };

    useEffect(() => {
        if (selectedCategory) {
            const filtered = videos.filter(v => parseInt(v.category) === parseInt(selectedCategory));
            setFilteredVideos(filtered);
            setSelectedVideo('');
            setVideoPreviewId('');
            setSmsContent('');
        } else {
            setFilteredVideos([]);
        }
    }, [selectedCategory, videos]);

    useEffect(() => {
        if (selectedVideo) {
            const video = videos.find(v => parseInt(v.id) === parseInt(selectedVideo));
            if (video) {
                setVideoPreviewId(video.youtube_video_id);
                setSmsContent(video.title + "\n" + eduUrl + video.youtube_video_id + '?refCode=' + 'smartcare');
            }
        } else {
            setVideoPreviewId('');
            setSmsContent('');
        }
    }, [selectedVideo, videos]);

    const handleSendSMS = async () => {
        if (!user || !smsContent) return;
        setIsLoading(true);
        try {
            const token = localStorage.getItem('token');
            const messageData = {
                message_type: '교육',
                title: '교육 영상 안내',
                content: smsContent,
                sender: localStorage.getItem('user_name') || '관리자',
                recipient: user.name,
                app_user_id: user.user_id, // 병원 연락처 꼬리말 판정에 쓰인다
                created_id: parseInt(localStorage.getItem('id') || 0),
                created_at: new Date().toISOString(),
                scheduled_date: null,
                sent_date: new Date().toISOString(),
                messages: [{
                    to: user.mobile,
                    content: smsContent
                }]
            };
            await axios.post('/api/messages/send-direct', messageData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            alert('교육 영상 문자가 성공적으로 발송되었습니다.');
            fetchHistory(); // 방금 보낸 영상 이력에 추가되도록
            // onClose(); // 사용자가 발송 이력을 확인할 수 있도록 모달을 유지합니다.

        } catch (error) {
            console.error('문자 발송 중 오류 발생:', error);
            alert('문자 발송 중 오류가 발생했습니다.');
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="dashboard-detail-send-modal">
            <div className="dashboard-detail-send-modal-content" style={{ width: '600px' }}>
                <div className="dashboard-detail-modal-header">
                    <h2 className="dashboard-detail-modal-title">교육영상 전송</h2>
                    <button className="dashboard-detail-close-button" onClick={onClose}>×</button>
                </div>

                <div className="dashboard-detail-form-group" style={{ marginBottom: '16px' }}>
                    <label style={{ fontSize: '14px', fontWeight: '700', color: '#333', display: 'block', marginBottom: '8px', textAlign: 'left' }}>
                        구분 :
                        <select
                            className="dashboard-detail-form-input"
                            value={selectedCategory}
                            onChange={e => setSelectedCategory(e.target.value)}
                            style={{ width: '85%', padding: '10px 12px', border: '1px solid #e1e1e1', borderRadius: '4px', fontSize: '14px', color: '#333', backgroundColor: '#fff', height: '38px', boxSizing: 'border-box', marginTop: '8px', marginLeft: '8px' }}
                        >
                            <option value="">카테고리 선택</option>
                            {categories.map(cat => (
                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                            ))}
                        </select>
                    </label>
                </div>

                <div className="dashboard-detail-form-group" style={{ marginBottom: '20px' }}>
                    <label style={{ fontSize: '14px', fontWeight: '700', color: '#333', display: 'block', marginBottom: '8px', textAlign: 'left' }}>
                        영상 :
                        <select
                            className="dashboard-detail-form-input"
                            value={selectedVideo}
                            onChange={e => setSelectedVideo(e.target.value)}
                            disabled={!selectedCategory}
                            style={{ width: '85%', padding: '10px 12px', border: '1px solid #e1e1e1', borderRadius: '4px', fontSize: '14px', color: '#333', backgroundColor: '#fff', height: '38px', boxSizing: 'border-box', marginTop: '8px', marginLeft: '8px' }}
                        >
                            <option value="">영상 선택</option>
                            {filteredVideos.map(vid => (
                                <option key={vid.id} value={vid.id}>{vid.title}</option>
                            ))}
                        </select>
                    </label>
                </div>

                {videoPreviewId && (
                    <div style={{ marginBottom: '16px', textAlign: 'center' }}>
                        <iframe
                            width="100%"
                            height="240"
                            src={`https://www.youtube.com/embed/${videoPreviewId}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Video Preview"
                        ></iframe>
                    </div>
                )}

                <div className="dashboard-detail-form-group" style={{ marginBottom: '16px' }}>
                    <label style={{ fontSize: '14px', fontWeight: '700', color: '#333', display: 'block', marginBottom: '8px', textAlign: 'left' }}>
                        메시지 내용 :
                        <textarea
                            className="dashboard-detail-form-textarea"
                            placeholder="선택한 영상의 제목이 여기에 표시됩니다."
                            value={smsContent}
                            onChange={e => setSmsContent(e.target.value)}
                            style={{ width: '100%', padding: '10px 12px', border: '1px solid #e1e1e1', borderRadius: '4px', fontSize: '14px', color: '#333', backgroundColor: '#fff', minHeight: '80px', boxSizing: 'border-box', marginTop: '8px', resize: 'vertical' }}
                        />
                    </label>
                </div>

                {/* 발송 이력 테이블 */}
                <div style={{ marginBottom: '20px', borderTop: '1px solid #eee', paddingTop: '16px' }}>
                    <h3 style={{ fontSize: '15px', fontWeight: '700', marginBottom: '12px', color: '#333', textAlign: 'left' }}>
                        발송 이력
                    </h3>
                    <div style={{ maxHeight: '180px', overflowY: 'auto', border: '1px solid #e1e1e1', borderRadius: '4px' }}>
                        {isHistoryLoading ? (
                            <div style={{ padding: '20px', textAlign: 'center', fontSize: '13px', color: '#666' }}>불러오는 중...</div>
                        ) : history.length === 0 ? (
                            <div style={{ padding: '20px', textAlign: 'center', fontSize: '13px', color: '#666' }}>발송 이력이 없습니다.</div>
                        ) : (
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', textAlign: 'center' }}>
                                <thead style={{ backgroundColor: '#f9f9f9', position: 'sticky', top: 0 }}>
                                    <tr>
                                        <th style={{ padding: '10px 8px', borderBottom: '1px solid #e1e1e1', fontWeight: '600', width: '30%' }}>발송일시</th>
                                        <th style={{ padding: '10px 8px', borderBottom: '1px solid #e1e1e1', fontWeight: '600', width: '20%' }}>발송자</th>
                                        <th style={{ padding: '10px 8px', borderBottom: '1px solid #e1e1e1', fontWeight: '600', width: '50%' }}>진행 내용</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {history.map((item, index) => (
                                        <tr key={item.id || index} style={{ borderBottom: '1px solid #eee' }}>
                                            <td style={{ padding: '8px', color: '#555' }}>
                                                {item.sent_date ? item.sent_date.substring(0, 16) : '-'}
                                            </td>
                                            <td style={{ padding: '8px', color: '#555' }}>{item.sender || '-'}</td>
                                            <td style={{ padding: '8px', textAlign: 'left', color: '#333', fontSize: '12px' }}>
                                                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                                                    {item.content}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>

                <div className="dashboard-detail-button-container">
                    <button
                        className="dashboard-detail-cancel-button"
                        onClick={onClose}
                    >
                        취소
                    </button>
                    <button
                        className="dashboard-detail-send-button"
                        onClick={handleSendSMS}
                        disabled={isLoading || !selectedVideo || !smsContent.trim()}
                    >
                        {isLoading ? '전송 중...' : '발송'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default EducationalVideoDialog;
